import { AssistantSuggestData } from '@vi-iot/client/apis/assistant/assistant.api-model';

export const suggestionsMockedData: AssistantSuggestData[] = [
  {
    label: 'Mono-V',
    class: 'product',
    concept: 'Mono-V',
    key: 'Mono V',
    query: 'V',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Festbrennstoffkessel\u001fStückholzkessel\u001fMono-V',
  },
  {
    label: 'RudoCell-V',
    class: 'product',
    concept: 'RudoCell-V',
    key: 'RudoCell V',
    query: 'V',
    classLabel: 'Product',
    attribute: 'product',
    value:
      'Trinkwassererwärmung und Heizwasserspeicherung\u001fSpeicher-Wassererwärmer (monovalent)\u001fRudoCell-V',
  },
  {
    label: 'Vitocell 100-V',
    class: 'product',
    concept: 'Vitocell 100-V',
    key: 'Vitocell 100 V',
    query: 'V',
    classLabel: 'Product',
    attribute: 'product',
    value:
      'Trinkwassererwärmung und Heizwasserspeicherung\u001fSpeicher-Wassererwärmer (monovalent)\u001fVitocell 100-V',
  },
  {
    label: 'Vitocell 200-V',
    class: 'product',
    concept: 'Vitocell 200-V',
    key: 'Vitocell 200 V',
    query: 'V',
    classLabel: 'Product',
    attribute: 'product',
    value:
      'Trinkwassererwärmung und Heizwasserspeicherung\u001fSpeicher-Wassererwärmer (monovalent)\u001fVitocell 200-V',
  },
  {
    label: 'Vitocell 300-V',
    class: 'product',
    concept: 'Vitocell 300-V',
    key: 'Vitocell 300 V',
    query: 'V',
    classLabel: 'Product',
    attribute: 'product',
    value:
      'Trinkwassererwärmung und Heizwasserspeicherung\u001fSpeicher-Wassererwärmer (monovalent)\u001fVitocell 300-V',
  },
  {
    label: 'Vitocell-V 100',
    class: 'product',
    concept: 'Vitocell-V 100',
    key: 'Vitocell V 100',
    query: 'V',
    classLabel: 'Product',
    attribute: 'product',
    value:
      'Trinkwassererwärmung und Heizwasserspeicherung\u001fSpeicher-Wassererwärmer (monovalent)\u001fVitocell-V 100',
  },
  {
    label: 'Vitocell-V 300',
    class: 'product',
    concept: 'Vitocell-V 300',
    key: 'Vitocell V 300',
    query: 'V',
    classLabel: 'Product',
    attribute: 'product',
    value:
      'Trinkwassererwärmung und Heizwasserspeicherung\u001fSpeicher-Wassererwärmer (monovalent)\u001fVitocell-V 300',
  },
  {
    label: 'Video',
    class: 'InformationType',
    concept: 'Video',
    key: 'Video',
    query: 'V',
    classLabel: 'Document type',
    attribute: 'InformationType',
    value: 'Video',
  },
  {
    label: 'VBE1323',
    class: 'Materialno',
    concept: 'VBE1323',
    key: 'VBE1323',
    query: 'V',
    classLabel: 'Materialnumber',
    attribute: 'Materialno',
    value: 'VBE1323',
  },
  {
    label: 'VBE1328',
    class: 'Materialno',
    concept: 'VBE1328',
    key: 'VBE1328',
    query: 'V',
    classLabel: 'Materialnumber',
    attribute: 'Materialno',
    value: 'VBE1328',
  },
  {
    label: 'VBE1623',
    class: 'Materialno',
    concept: 'VBE1623',
    key: 'VBE1623',
    query: 'V',
    classLabel: 'Materialnumber',
    attribute: 'Materialno',
    value: 'VBE1623',
  },
  {
    label: 'VBE1628',
    class: 'Materialno',
    concept: 'VBE1628',
    key: 'VBE1628',
    query: 'V',
    classLabel: 'Materialnumber',
    attribute: 'Materialno',
    value: 'VBE1628',
  },
  {
    label: 'VBE1673',
    class: 'Materialno',
    concept: 'VBE1673',
    key: 'VBE1673',
    query: 'V',
    classLabel: 'Materialnumber',
    attribute: 'Materialno',
    value: 'VBE1673',
  },
  {
    label: 'VBE1683',
    class: 'Materialno',
    concept: 'VBE1683',
    key: 'VBE1683',
    query: 'V',
    classLabel: 'Materialnumber',
    attribute: 'Materialno',
    value: 'VBE1683',
  },
  {
    label: 'VBE1822',
    class: 'Materialno',
    concept: 'VBE1822',
    key: 'VBE1822',
    query: 'V',
    classLabel: 'Materialnumber',
    attribute: 'Materialno',
    value: 'VBE1822',
  },
  {
    label: 'VBE1827',
    class: 'Materialno',
    concept: 'VBE1827',
    key: 'VBE1827',
    query: 'V',
    classLabel: 'Materialnumber',
    attribute: 'Materialno',
    value: 'VBE1827',
  },
  {
    label: 'VBE2023',
    class: 'Materialno',
    concept: 'VBE2023',
    key: 'VBE2023',
    query: 'V',
    classLabel: 'Materialnumber',
    attribute: 'Materialno',
    value: 'VBE2023',
  },
  {
    label: 'VBE2028',
    class: 'Materialno',
    concept: 'VBE2028',
    key: 'VBE2028',
    query: 'V',
    classLabel: 'Materialnumber',
    attribute: 'Materialno',
    value: 'VBE2028',
  },
  {
    label: 'VBE2073',
    class: 'Materialno',
    concept: 'VBE2073',
    key: 'VBE2073',
    query: 'V',
    classLabel: 'Materialnumber',
    attribute: 'Materialno',
    value: 'VBE2073',
  },
  {
    label: 'VBE2083',
    class: 'Materialno',
    concept: 'VBE2083',
    key: 'VBE2083',
    query: 'V',
    classLabel: 'Materialnumber',
    attribute: 'Materialno',
    value: 'VBE2083',
  },
  {
    label: '§Vi Energy Management',
    class: 'product',
    concept: 'HEMS',
    key: 'Vi Energy Management',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'HEMS',
  },
  {
    label: 'Video',
    class: 'InformationType',
    concept: 'Video',
    key: 'Video',
    query: 'Vi',
    classLabel: 'Document type',
    attribute: 'InformationType',
    value: 'Video',
  },
  {
    label: 'ViGuide',
    class: 'product',
    concept: 'ViGuide',
    key: 'ViGuide',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Zubehör/Systemtechnik\u001fKommunikation\u001fDaten-Kommunikation\u001fViGuide',
  },
  {
    label: 'VitoCell-biferral',
    class: 'product',
    concept: 'VitoCell-biferral',
    key: 'VitoCellbiferral',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitoCell-biferral',
  },
  {
    label: 'VitoCell-comferral',
    class: 'product',
    concept: 'VitoCell-comferral',
    key: 'VitoCellcomferral',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value:
      'Mittel- und Großkessel\u001fÖl-/Gas-Niedertemperatur-Heizkessel\u001fVitoCell-comferral',
  },
  {
    label: 'VitoCell-uniferral',
    class: 'product',
    concept: 'VitoCell-uniferral',
    key: 'VitoCelluniferral',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitoCell-uniferral',
  },
  {
    label: 'Vitoair',
    class: 'product',
    concept: 'Vitoair',
    key: 'Vitoair',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Zubehör/Systemtechnik\u001fAbgas\u001fSonstiges Zubehör\u001fVitoair',
  },
  {
    label: 'Vitobloc',
    class: 'product',
    concept: 'Vitobloc',
    key: 'Vitobloc',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Kraft-Wärme-Kopplung\u001fBHKW\u001fVitobloc',
  },
  {
    label: 'Vitocharge',
    class: 'product',
    concept: 'Vitocharge',
    key: 'Vitocharge',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Photovoltaik\u001fStromspeicher-Systeme\u001fVitocharge',
  },
  {
    label: 'Vitoclima-C',
    class: 'product',
    concept: 'Vitoclima-C',
    key: 'VitoclimaC',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Klima- und Kühlsysteme\u001fKaltwassersätze\u001fVitoclima-C',
  },
  {
    label: 'Vitocontrol',
    class: 'product',
    concept: 'Vitocontrol',
    key: 'Vitocontrol',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Zubehör/Systemtechnik\u001fElektrisch\u001fFernbedienungen\u001fVitocontrol',
  },
  {
    label: 'Vitocrossal',
    class: 'product',
    concept: 'Vitocrossal',
    key: 'Vitocrossal',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Gas-Heizkessel\u001fGas-Brennwertkessel bodenstehend\u001fVitocrossal',
  },
  {
    label: 'Vitoflow',
    class: 'product',
    concept: 'Vitoflow',
    key: 'Vitoflow',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Zubehör/Systemtechnik\u001fHydraulisch\u001fHydraulischer Abgleich\u001fVitoflow',
  },
  {
    label: 'Vitofriocal',
    class: 'product',
    concept: 'Vitofriocal',
    key: 'Vitofriocal',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Wärmepumpen\u001fEis-Energiespeicher\u001fVitofriocal',
  },
  {
    label: 'Vitogas-100',
    class: 'product',
    concept: 'Vitogas-100',
    key: 'Vitogas100',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Vitogas-100',
  },
  {
    label: 'Vitoguide',
    class: 'product',
    concept: 'Vitoguide',
    key: 'Vitoguide',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Zubehör/Systemtechnik\u001fKommunikation\u001fDaten-Kommunikation\u001fVitoguide',
  },
  {
    label: 'Vitola-R',
    class: 'product',
    concept: 'Vitola-R',
    key: 'VitolaR',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Niedertemperatur-Heizkessel\u001fVitola-R',
  },
  {
    label: 'Vitola-biferral',
    class: 'product',
    concept: 'Vitola-biferral',
    key: 'Vitolabiferral',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitola-biferral',
  },
  {
    label: 'Vitola-biferral-2',
    class: 'product',
    concept: 'Vitola-biferral-2',
    key: 'Vitolabiferral2',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitola-biferral-2',
  },
  {
    label: 'Vitola-biferral-FB',
    class: 'product',
    concept: 'Vitola-biferral-FB',
    key: 'VitolabiferralFB',
    query: 'Vi',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitola-biferral-FB',
  },
  {
    label: 'VitoCell-biferral',
    class: 'product',
    concept: 'VitoCell-biferral',
    key: 'VitoCellbiferral',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitoCell-biferral',
  },
  {
    label: 'VitoCell-comferral',
    class: 'product',
    concept: 'VitoCell-comferral',
    key: 'VitoCellcomferral',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value:
      'Mittel- und Großkessel\u001fÖl-/Gas-Niedertemperatur-Heizkessel\u001fVitoCell-comferral',
  },
  {
    label: 'VitoCell-uniferral',
    class: 'product',
    concept: 'VitoCell-uniferral',
    key: 'VitoCelluniferral',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitoCell-uniferral',
  },
  {
    label: 'Vitoair',
    class: 'product',
    concept: 'Vitoair',
    key: 'Vitoair',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Zubehör/Systemtechnik\u001fAbgas\u001fSonstiges Zubehör\u001fVitoair',
  },
  {
    label: 'Vitobloc',
    class: 'product',
    concept: 'Vitobloc',
    key: 'Vitobloc',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Kraft-Wärme-Kopplung\u001fBHKW\u001fVitobloc',
  },
  {
    label: 'Vitocharge',
    class: 'product',
    concept: 'Vitocharge',
    key: 'Vitocharge',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Photovoltaik\u001fStromspeicher-Systeme\u001fVitocharge',
  },
  {
    label: 'Vitoclima-C',
    class: 'product',
    concept: 'Vitoclima-C',
    key: 'VitoclimaC',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Klima- und Kühlsysteme\u001fKaltwassersätze\u001fVitoclima-C',
  },
  {
    label: 'Vitocontrol',
    class: 'product',
    concept: 'Vitocontrol',
    key: 'Vitocontrol',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Zubehör/Systemtechnik\u001fElektrisch\u001fFernbedienungen\u001fVitocontrol',
  },
  {
    label: 'Vitocrossal',
    class: 'product',
    concept: 'Vitocrossal',
    key: 'Vitocrossal',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Gas-Heizkessel\u001fGas-Brennwertkessel bodenstehend\u001fVitocrossal',
  },
  {
    label: 'Vitoflow',
    class: 'product',
    concept: 'Vitoflow',
    key: 'Vitoflow',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Zubehör/Systemtechnik\u001fHydraulisch\u001fHydraulischer Abgleich\u001fVitoflow',
  },
  {
    label: 'Vitofriocal',
    class: 'product',
    concept: 'Vitofriocal',
    key: 'Vitofriocal',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Wärmepumpen\u001fEis-Energiespeicher\u001fVitofriocal',
  },
  {
    label: 'Vitogas-100',
    class: 'product',
    concept: 'Vitogas-100',
    key: 'Vitogas100',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Vitogas-100',
  },
  {
    label: 'Vitoguide',
    class: 'product',
    concept: 'Vitoguide',
    key: 'Vitoguide',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Zubehör/Systemtechnik\u001fKommunikation\u001fDaten-Kommunikation\u001fVitoguide',
  },
  {
    label: 'Vitola-R',
    class: 'product',
    concept: 'Vitola-R',
    key: 'VitolaR',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Niedertemperatur-Heizkessel\u001fVitola-R',
  },
  {
    label: 'Vitola-biferral',
    class: 'product',
    concept: 'Vitola-biferral',
    key: 'Vitolabiferral',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitola-biferral',
  },
  {
    label: 'Vitola-biferral-2',
    class: 'product',
    concept: 'Vitola-biferral-2',
    key: 'Vitolabiferral2',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitola-biferral-2',
  },
  {
    label: 'Vitola-biferral-FB',
    class: 'product',
    concept: 'Vitola-biferral-FB',
    key: 'VitolabiferralFB',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitola-biferral-FB',
  },
  {
    label: 'Vitola-biferral-RN',
    class: 'product',
    concept: 'Vitola-biferral-RN',
    key: 'VitolabiferralRN',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitola-biferral-RN',
  },
  {
    label: 'Vitola-biferral-WP',
    class: 'product',
    concept: 'Vitola-biferral-WP',
    key: 'VitolabiferralWP',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitola-biferral-WP',
  },
  {
    label: 'Vitola-comferral',
    class: 'product',
    concept: 'Vitola-comferral',
    key: 'Vitolacomferral',
    query: 'Vit',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Niedertemperatur-Heizkessel\u001fVitola-comferral',
  },
  {
    label: 'VitoCell-biferral',
    class: 'product',
    concept: 'VitoCell-biferral',
    key: 'VitoCellbiferral',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitoCell-biferral',
  },
  {
    label: 'VitoCell-comferral',
    class: 'product',
    concept: 'VitoCell-comferral',
    key: 'VitoCellcomferral',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value:
      'Mittel- und Großkessel\u001fÖl-/Gas-Niedertemperatur-Heizkessel\u001fVitoCell-comferral',
  },
  {
    label: 'VitoCell-uniferral',
    class: 'product',
    concept: 'VitoCell-uniferral',
    key: 'VitoCelluniferral',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitoCell-uniferral',
  },
  {
    label: 'Vitoair',
    class: 'product',
    concept: 'Vitoair',
    key: 'Vitoair',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Zubehör/Systemtechnik\u001fAbgas\u001fSonstiges Zubehör\u001fVitoair',
  },
  {
    label: 'Vitobloc',
    class: 'product',
    concept: 'Vitobloc',
    key: 'Vitobloc',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Kraft-Wärme-Kopplung\u001fBHKW\u001fVitobloc',
  },
  {
    label: 'Vitocharge',
    class: 'product',
    concept: 'Vitocharge',
    key: 'Vitocharge',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Photovoltaik\u001fStromspeicher-Systeme\u001fVitocharge',
  },
  {
    label: 'Vitoclima-C',
    class: 'product',
    concept: 'Vitoclima-C',
    key: 'VitoclimaC',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Klima- und Kühlsysteme\u001fKaltwassersätze\u001fVitoclima-C',
  },
  {
    label: 'Vitocontrol',
    class: 'product',
    concept: 'Vitocontrol',
    key: 'Vitocontrol',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Zubehör/Systemtechnik\u001fElektrisch\u001fFernbedienungen\u001fVitocontrol',
  },
  {
    label: 'Vitocrossal',
    class: 'product',
    concept: 'Vitocrossal',
    key: 'Vitocrossal',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Gas-Heizkessel\u001fGas-Brennwertkessel bodenstehend\u001fVitocrossal',
  },
  {
    label: 'Vitoflow',
    class: 'product',
    concept: 'Vitoflow',
    key: 'Vitoflow',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Zubehör/Systemtechnik\u001fHydraulisch\u001fHydraulischer Abgleich\u001fVitoflow',
  },
  {
    label: 'Vitofriocal',
    class: 'product',
    concept: 'Vitofriocal',
    key: 'Vitofriocal',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Wärmepumpen\u001fEis-Energiespeicher\u001fVitofriocal',
  },
  {
    label: 'Vitogas-100',
    class: 'product',
    concept: 'Vitogas-100',
    key: 'Vitogas100',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Vitogas-100',
  },
  {
    label: 'Vitoguide',
    class: 'product',
    concept: 'Vitoguide',
    key: 'Vitoguide',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Zubehör/Systemtechnik\u001fKommunikation\u001fDaten-Kommunikation\u001fVitoguide',
  },
  {
    label: 'Vitola-R',
    class: 'product',
    concept: 'Vitola-R',
    key: 'VitolaR',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Niedertemperatur-Heizkessel\u001fVitola-R',
  },
  {
    label: 'Vitola-biferral',
    class: 'product',
    concept: 'Vitola-biferral',
    key: 'Vitolabiferral',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitola-biferral',
  },
  {
    label: 'Vitola-biferral-2',
    class: 'product',
    concept: 'Vitola-biferral-2',
    key: 'Vitolabiferral2',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitola-biferral-2',
  },
  {
    label: 'Vitola-biferral-FB',
    class: 'product',
    concept: 'Vitola-biferral-FB',
    key: 'VitolabiferralFB',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitola-biferral-FB',
  },
  {
    label: 'Vitola-biferral-RN',
    class: 'product',
    concept: 'Vitola-biferral-RN',
    key: 'VitolabiferralRN',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitola-biferral-RN',
  },
  {
    label: 'Vitola-biferral-WP',
    class: 'product',
    concept: 'Vitola-biferral-WP',
    key: 'VitolabiferralWP',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Tieftemperatur-Heizkessel\u001fVitola-biferral-WP',
  },
  {
    label: 'Vitola-comferral',
    class: 'product',
    concept: 'Vitola-comferral',
    key: 'Vitolacomferral',
    query: 'Vito',
    classLabel: 'Product',
    attribute: 'product',
    value: 'Mittel- und Großkessel\u001fÖl-/Gas-Niedertemperatur-Heizkessel\u001fVitola-comferral',
  },
];
